module.exports = __webpack_public_path__ + "images/placeholder-eecd01548f97190104c6502fbc8dbebe.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/placeholder.png
// module id = ./client/assets/images/placeholder.png
// module chunks = 5 7 8 9 10